import AbstractField from "./AbstractField";

export default class NameField extends AbstractField {
    isInputField = true;
    idValue = null;
    showInDrawMode = false;

    id(id) {
        this.idValue = id;
        return this;
    }

    input(func) {
        this.initialized
            ? this.inputElement.input(func)
            : this.inputFunction = func;
        return this;
    }

    populate(element) {
        this.labelDiv.html(element.title);
        this.inputElement.value(element.name);
    }

    make() {
        this.field = this.p.createDiv();
        this.labelDiv = this.p.createDiv()
            .parent(this.field)
            .class('input-label');
        this.parentElement ? this.field.parent(this.parentElement) : null;

        this.inputContainer = this.p.createDiv()
            .parent(this.field)
            .style('display', 'flex')
            .style('align-items', 'center');

        this.inputElement = this.p.createInput('')
            .parent(this.inputContainer)
            .class('name-input input-text')
            .id(this.idValue)
            .input(() => this.setValue());

        this.setFocusAndBlurActions();

        this.followLabel = this.p.createDiv()
            .parent(this.inputContainer)
            .class('mode-selector-option')
            .attribute('data-tooltip', "As label")
            .mouseClicked(() => {
                let element = this.element;
                element._name = null
                this.value(element.name);
                element.row.updateLabel();
                this.changesMade();
            });

        let icon = SVG().addTo(this.followLabel.elt);
        icon.addClass('icon');
        icon.use('file-copy-2-line', '/icons/__remixicon.sprite.svg');

        this.initialized = true;
        return this;
    }

    value(value) {
        if (value === undefined) {
            return this.inputElement.value();
        }
        this.inputElement.value(value);
        return this;
    }

    setValue() {
        let currentElement = this.element;
        currentElement._name = this.inputElement.value();
        currentElement.row.updateLabel();
        this.changesMade();
    }

    focus() {
        this.inputElement.elt.focus();
    }

    setFocusAndBlurActions() {
        this.inputElement.elt.onfocus = () => {
            this.enableHotKeys = false
            this.getTab('info').activeInput = this.inputElement;
        };
        this.inputElement.elt.onblur = () => {
            this.enableHotKeys = true
            let activeInput = this.getTab('info').activeInput;
            this.getTab('info').activeInput = activeInput == this.inputElement
                ? null
                : activeInput;
        };
    }

    reset() {
        this.labelDiv.html('');
        this.inputElement.value('');
    }
}
